import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials: send/receive the httpOnly auth cookie. Frontend and backend
// share the same origin (preview + prod), so the cookie flows automatically.
const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  // Backward-compat: legacy sessions still carry a Bearer token in localStorage.
  // New sessions are cookie-only (no token written to localStorage).
  const token = localStorage.getItem("fintech_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => {
    // Sliding session for legacy (Bearer) clients only: the backend issues a
    // refreshed JWT via this header. We only persist it when a legacy token
    // already exists — cookie-only sessions never get a token exposed to JS.
    const newToken = r?.headers?.["x-new-token"] || r?.headers?.["X-New-Token"];
    if (newToken && localStorage.getItem("fintech_token")) {
      try { localStorage.setItem("fintech_token", newToken); }
      catch (e) {
        if (process.env.NODE_ENV !== "production") console.warn("token persist failed:", e?.message);
      }
    }
    return r;
  },
  (err) => {
    if (err?.response?.status === 401) {
      // allow auth context to handle redirect
    }
    return Promise.reject(err);
  }
);

export default api;
